import { FeedbackActionEnum } from '@daymade/api-contracts';
import FeedbackPopup from 'components/my-prizes/FeedbackPopup';
import { useState } from 'react';
import { feedbackApiClient } from 'utils/apiClient';
import { ASSET_PREFIX } from 'utils/constants';
import styles from './StarRatingSelector.module.css';

const MAX_STAR_COUNT = 5;

interface IStarRatingSelectorProps {
  prizeWinId: string;
  existingRating: number | null;
  existingComment: string | null;
}

const StarRatingSelector = ({
  prizeWinId,
  existingRating,
  existingComment,
}: IStarRatingSelectorProps) => {
  const [rating, setRating] = useState(existingRating);
  const [comment, setComment] = useState(existingComment);
  const [submitted, setSubmitted] = useState(false);
  const [showFeedbackPopup, setShowFeedbackPopup] = useState(false);

  const disabled = existingRating !== null;
  const edited = existingRating !== rating;

  const submitFeedback = async (rating: number, comment: string) => {
    const trimmedString = comment.trim();
    const commentToSubmit = trimmedString.length > 0 ? trimmedString : null;
    await feedbackApiClient.public.sendFeedback({
      body: {
        action: FeedbackActionEnum.CLAIM_PRIZE_WIN,
        feedback: {
          [FeedbackActionEnum.CLAIM_PRIZE_WIN]: {
            rating,
            comment: commentToSubmit || undefined,
          },
        },
        refId: prizeWinId,
      },
    });
    return commentToSubmit;
  };

  return (
    <>
      <p className={`aboutUsTypographyBodySmall ${styles.question}`}>
        How was it?
      </p>

      <div className={styles.container}>
        {Array(MAX_STAR_COUNT)
          .fill(null)
          .map((_, i) => (
            <img
              key={i + 1}
              src={`${ASSET_PREFIX}/images/prizes/star${rating && rating >= i + 1 ? '-filled' : ''}.svg`}
              onClick={() => !disabled && !submitted && setRating(i + 1)}
              className={`${styles.star} ${disabled || submitted ? styles.disabled : ''}`}
            />
          ))}

        {edited && !submitted && (
          <span className={styles.confirm}>
            <img
              src={`${ASSET_PREFIX}/images/prizes/confirm-rating-tick.svg`}
              onClick={async () => {
                setShowFeedbackPopup(true);
              }}
              className={`${styles.confirmButton} ${disabled || submitted ? styles.disabled : ''}`}
            />
          </span>
        )}

        {/* Figure out what to do about comments when this gets redesigned
        {comment && (
          <p style={{ marginTop: '1em', fontStyle: 'italic' }}>"{comment}"</p>
        )} */}

        {showFeedbackPopup && (
          <FeedbackPopup
            rating={rating!}
            onClose={async (input) => {
              const submittedComment = await submitFeedback(rating!, input);
              setSubmitted(true);
              setComment(submittedComment);
              setShowFeedbackPopup(false);
            }}
          />
        )}
      </div>
    </>
  );
};

export default StarRatingSelector;
